import User from "./User";
import Setting from "./Setting";
import Customer from "./Customer";
import DocumentTemplate from "./DocumentTemplate";

export default {
  User,
  Setting,
  Customer,
  DocumentTemplate,
};
